import { render, staticRenderFns } from "./countdownItem.vue?vue&type=template&id=c63d5a10&"
import script from "./countdownItem.vue?vue&type=script&lang=js&"
export * from "./countdownItem.vue?vue&type=script&lang=js&"
import style0 from "./countdownItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports